module.exports = new __parcel__URL__("Marketing Campaign Hover.5784e467.svg").toString();